import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'PAD_LIST_CLIENT';

export default createListReducer(TEMPLATE_NAME);
